<template>
    <div class="app">
        <el-container>
            <el-aside class="app-side app-side-left"
                      :class="isCollapse ? 'app-side-collapsed' : 'app-side-expanded'">
                <div class="app-side-logo" style="background-color: #333547">

                    <img v-if="isCollapse"   src="../assets/img/logo-sm.png"
                         width="60"
                         height="60" />
                    <img v-else  src="../assets/img/logo-light.png"
                         width="90%"
                         height="50" />

                </div>
                <div>
                    <!-- 我是样例菜单 -->
                    <el-menu
                            default-active="1-4-1"
                            class="el-menu-vertical-demo"
                            @open="handleOpen"
                            @close="handleClose"
                            :collapse="isCollapse"
                            router
                            background-color="#333547"
                            text-color="#fff"
                            active-text-color="#ffd04b"
                    >

                        <el-menu-item  index="/rmaList/0">
                            <i class="el-icon-tickets"></i>
                            <span slot="title">RMA LIST</span>
                        </el-menu-item>

                        <el-menu-item  index="/rmaList/1">
                            <i class="el-icon-tickets"></i>
                            <span slot="title">RMA CLOSED LIST  </span>
                        </el-menu-item>
                        <el-menu-item v-if="isadmin" index="/userList">
                            <i class="el-icon-s-custom"></i>
                            <span slot="title">USERS LIST</span>
                        </el-menu-item>
                        <el-menu-item v-if="role===1" index="/em/add">
                            <i class="el-icon-s-tools"></i>
                            <span slot="title">EMAIL SETTING</span>
                        </el-menu-item>
                        <el-menu-item v-if="role===1" index="/set/add">
                            <i class="el-icon-s-tools"></i>
                            <span slot="title">FIELD SETTING</span>
                        </el-menu-item>
                        <el-menu-item v-if="role===1" index="/ad/add">
                            <i class="el-icon-s-tools"></i>
                            <span slot="title">ADRESS SETTING</span>
                        </el-menu-item>
                    </el-menu>
                </div>
            </el-aside>

            <el-container>
                <el-header class="app-header">

                    <div style="width: 60px; cursor: pointer;"
                         @click.prevent="toggleSideBar">
                        <i v-show="!isCollapse" class="el-icon-d-arrow-left"></i>
                        <i v-show="isCollapse" class="el-icon-d-arrow-right"></i>
                    </div>

                    <!-- 我是样例菜单 -->


                    <div class="app-header-userinfo" style="top: 0px">
                        <el-dropdown trigger="hover"
                                     :hide-on-click="false">
              <span class="el-dropdown-link" style="cursor: pointer;">
                {{username}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                            <el-dropdown-menu slot="dropdown">

                                <el-dropdown-item divided
                                                  @click.native="logout">Login Out</el-dropdown-item>
                                <el-dropdown-item divided
                                                  @click.native="showeditPass">Change Password</el-dropdown-item>
                                <el-dropdown-item divided
                                                  @click.native="showself">Modify Information</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>

                </el-header>


                <el-dialog
                        title="Change Password"
                        :visible.sync="editPassVisible" @click="editPassClose">
                    <el-form :model="editPassForm" :rules="rules" ref="editPassFormRef">
                        <el-form-item prop="password" label="Please enter the password">
                            <el-input v-model="editPassForm.password" type="password" ></el-input>
                        </el-form-item>
                        <el-form-item prop="password1" label="Please enter the password again">
                            <el-input  v-model="editPassForm.password1" type="password" ></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                <el-button @click="editPassVisible = false">Cancel</el-button>
                <el-button type="primary" @click="editPass">submit</el-button>
            </span>
                </el-dialog>
                <el-dialog
                        title="Modify information"
                        :visible.sync="editselfVisible" @click="editselfClose">
                    <el-form :model="editselfForm"  ref="editPassFormRef">
                        <el-form-item prop="id" label="id" hidden>
                            <el-input v-model="editselfForm.id" type="text" ></el-input>
                        </el-form-item>
                        <el-form-item prop="name" label="Name">
                            <el-input v-model="editselfForm.name" type="text" ></el-input>
                        </el-form-item>
                        <el-form-item prop="firstname" label="firstname">
                            <el-input v-model="editselfForm.firstname" type="text" ></el-input>
                        </el-form-item>
                        <el-form-item prop="lastname" label="lastname">
                            <el-input v-model="editselfForm.lastname" type="text" ></el-input>
                        </el-form-item>
                        <el-form-item prop="email" label="Email">
                            <el-input v-model="editselfForm.email" type="text" ></el-input>
                        </el-form-item>
                        <el-form-item prop="company" label="Company Name">
                            <el-input v-model="editselfForm.company" type="text" ></el-input>
                        </el-form-item>
                        <el-form-item prop="country" label="Company Adress">
                            <el-input v-model="editselfForm.country" type="text" ></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="Phone">
                            <el-input v-model="editselfForm.phone" type="text" ></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                <el-button @click="editselfVisible = false">Cancel</el-button>
                <el-button type="primary" @click="editself">Submit</el-button>
            </span>
                </el-dialog>
                <el-main class="app-body">
                    <template>
                        <router-view v-if="isRouterAlive"/>
                    </template>
                </el-main>
                <el-footer>Copyright © 2020 Sunwave Communications Co., Ltd. All rights reserved.</el-footer>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    export default {
        name: 'Container',
        data() {
            return {

                username: '',
                isCollapse: false,
                isRouterAlive:true,
                isadmin:false,
                password:"",
                password1:"",
                role:'',
                editPassForm:{},
                editPassVisible:false,
                editselfForm:{},
                editselfVisible:false,
                rules:{
                    password: [
                        { required: true, message: 'Can not be empty', trigger: 'blur' },
                    ],
                    password1: [
                        { required: true, message: 'Can not be empty', trigger: 'blur' },
                    ],
                },
            }
        },
        created() {

            this.getRole();
        },
        methods: {
            toggleSideBar() {
                this.isCollapse = !this.isCollapse
                // if(this.isCollapse===true){
                //     localStorage.setItem('mainwidth',document.body.clientWidth-310 + "px");
                // }else {
                //     localStorage.setItem('mainwidth',document.body.clientWidth-70 + "px");
                // }
            },
            logout: function () {
                this.$confirm('Confirm Exit?', 'Prompt', {})
                    .then(() => {
                        localStorage.clear();
                        this.$router.push('/login');
                    })
                    .catch(() => { });
            },


            async getRole(){
                const token=localStorage.getItem("token");

                this.username=localStorage.getItem("username");
                const result=await this.$http.get("user/getRole/"+token);

                if(result.data.error_code===0){
                    localStorage.setItem('role',result.data.data.role);
                    this.role=result.data.data.role;
                    console.log(this.role)
                    if(result.data.data.role<3){
                        this.isadmin=true;
                    }
                }else {
                    this.$message.success("Failed to obtain user role");
                }
            },

            editPassClose(){
                this.editPassVisible=false;

            },
            editselfClose(){
                this.editselfVisible=false;

            },
            async showeditPass(){
                this.editPassVisible=true;
            },
            async showself(){
                const result=await this.$http.get("user/infoself");
                this.editselfForm=result.data.data;
                this.editselfVisible=true;
            },

            async editself() {


                    const result=await this.$http.post("user/edit",this.editselfForm);

                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        this.editselfVisible=false;

                    }
            },
            editPass() {
                this.$refs.editPassFormRef.validate(async valid => {
                    if (!valid) {
                        console.log('error submit!!');
                        return false;
                    }
                    const result=await this.$http.post("user/editpass",this.editPassForm);
                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        this.editPassVisible=false;
                    }
                });
            },
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            },
        },
        mounted: function () {
            let user = sessionStorage.getItem('user');
            if (user) {
                this.username = user;
            }
        },
    }
</script>

<style>

    .el-footer{

        text-align: center;
        padding: 15px;
    }
</style>
